import { useLocation, useParams } from 'react-router-dom';

export const useQueryParams = () => {
  const routeParams = useParams();
  const location = useLocation();
  const queryStringParams = new URLSearchParams(location.search);

  const getParam = (
    name: string,
    defaultValue?: string,
  ): string | undefined => {
    return routeParams[name] || queryStringParams.get(name) || defaultValue;
  };

  return {
    getParam,
    routeParams,
    queryStringParams,
  };
};
